
















import { Vue, Component, Prop } from 'vue-property-decorator';
import { IUser } from '@/types/User';
import Avatar from '@/components/Avatar.vue';
import { IRecipient } from '@/types/Recipient';

@Component({
  components: {
    Avatar,
  },
})
export default class Person extends Vue {
  @Prop() user?: IUser;
  @Prop() recipient?: IRecipient;
  @Prop({ default: false }) enableHover?: boolean;
  @Prop({ default: false }) showEmail?: boolean;
  @Prop() borderColor?: string;
  @Prop({ default: false }) dark: boolean;
  @Prop({ default: false }) shadow: boolean;
  @Prop({ default: false }) small: boolean;

  get name(): string {
    if (this.showTemplateRole) {
      return !!this.recipient && this.recipient.roleName;
    }
    return (
      (!!this.user && this.getFullName(this.user)) ||
      (!!this.recipient && this.getFullName(this.recipient))
    );
  }

  get role(): string {
    return this.recipient ? this.recipient.role : '';
  }

  get email(): string {
    return this.recipient ? this.recipient.email : this.user.email;
  }

  get showTemplateRole(): boolean {
    return (
      !!this.recipient &&
      !!this.recipient.roleName &&
      this.recipient.roleName !== '' &&
      !this.recipient.email
    );
  }

  get thumbUrl(): string {
    if (this.user) {
      return this.user.thumbUrl;
    } else if (this.recipient) {
      return this.recipient.thumbUrl;
    }
    return '';
  }

  getFullName(person: IUser | IRecipient): string {
    return person.fullName || `${person.firstName || ''} ${person.lastName || ''}`;
  }

  select(): void {
    this.$emit('select', this.user || this.recipient);
  }
}
